import { useQuery } from '@tanstack/react-query';
import { get } from '@/shared/api/api-client';
import type {
  GenderMasterItem,
  LicenseAuthorityItem,
} from '@/types/settings-api';

/**
 * Master-data lookups for Settings forms — PROD-761 / PROD-788 / PROD-790.
 *
 * Both hooks return STABLE backend data (rarely changes); cached for the
 * session with `staleTime: Infinity`.
 *
 * Wire-shape note: `GenderMasterItem` is camelCase (`id` / `name`) while
 * `LicenseAuthorityItem` is **PascalCase** (`Id` / `Name`). Verified
 * verbatim against dev cURLs 2026-05-13. Don't normalise — types reflect
 * the wire exactly so consumers can't accidentally write a key the
 * backend won't read.
 */

export function useGenderMaster() {
  return useQuery({
    queryKey: ['settings', 'master', 'gender'],
    queryFn: ({ signal }) =>
      get<GenderMasterItem[]>('/api/Master/Gender', { signal }),
    staleTime: Infinity,
  });
}

export function useLicenseAuthorities() {
  return useQuery({
    queryKey: ['settings', 'master', 'license-authority'],
    queryFn: ({ signal }) =>
      get<LicenseAuthorityItem[]>('/api/Master/LicenseAuthority', { signal }),
    staleTime: Infinity,
  });
}
